export enum UserVerification {
  UNVERIFIED = 1, // for Unverified / Pending users
  VERIFIED = 2
}
